import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../Core/Container';
import { ProTipWrapper } from '../Video/VideoTutorialVideoPlayer/styles';

export const StyledContainer = styled(Container)`
  ${ProTipWrapper}.video-tip &,
  &.internal {
    margin: 0;
    width: 100%;
  }

  &.internal {
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      position: absolute;
      bottom: 0;
      margin-bottom: 1rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin-bottom: 0rem;
    }
  }
`;

export const Wrapper = styled.div`
  margin-top: 40px;
  border: 1px dashed ${themeGet('colors.yellow')};
  border-left: 2px solid ${themeGet('colors.yellow')};
  background-color: rgba(251, 182, 0, 0.02);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 40px;

  ${StyledContainer}.calculator & {
    border: none;
    border-top-right-radius: 0.3125rem;
    border-bottom-right-radius: 0.3125rem;
    border-bottom-left-radius: 0.3125rem;
    border-top-left-radius: 0.3125rem;
    background-color: #f2f2f2;
    padding: 1rem 2rem;
  }

  ${StyledContainer}.internal & {
    margin-top: 0;
  }
`;

export const Heading = styled.span`
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: ${themeGet('fontWeights.bold')};

  ${Wrapper}.no-icon & {
    position: relative;

    &:before {
      content: '';
      display: inline-block;
      width: 100%;
      height: 100%;
      max-width: 32px;
      max-height: 32px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      margin-left: -52px;
    }
  }

  ${StyledContainer}.calculator & {
    font-size: 0.875rem;
    font-weight: normal;
    line-height: 1.5rem;
  }
`;

export const Body = styled.div`
  margin-top: 1.25rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-left: 52px;
  }

  ${Wrapper}.no-icon & {
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-left: 0;
    }
  }
`;
